<div ng-class="{'active': model}" 
    class="d-flex switch-button"
    ng-click="toggle()">
    <span class="switch-knob"></span>
</div>